import Langugaes from "../components/internationalization/languages";
import UserService from "../services/user-service";

// initialization of sessionStorage from localStorage
export const setUserInSessionStore = () => {
  if (!sessionStorage.vuex) {
    if (localStorage.getItem("user")) {
      const localStoreUserData = JSON.parse(localStorage.getItem("user"));
      if (localStoreUserData.token) {
        let userData = {
          token: localStoreUserData.token,
          master: localStoreUserData.master,
          name: localStoreUserData.name,
          credentials: localStoreUserData.credentials
        };
        window.store.commit("user/setUser", userData);
      }
    }
  }
};

// get currently loggedIn user
export const getLoggedInUser = () => {
  if (sessionStorage.vuex) {
    const sessionStoreUserData = JSON.parse(sessionStorage.vuex);
    if (sessionStoreUserData.user.user.token) {
      return true;
    } else {
      return false;
    }
  } else {
    return false;
  }
};

export const loginUser = async userName => {
  let response;
  try {
    response = await UserService.login(userName, "");
  } catch (e) {
    return false;
  }
  if (!response.status) {
    window.store.commit("user/setUser", {
      name: userName,
      token: response.token,
      master: response.master,
      credentials: response.credentials
    });
    return userName;
  } else {
    return false;
  }
};
//method to get index from an array by label property
export const getIndexByLabel = (array, label) => {
  return array.findIndex(x => x.label === label);
};

//method to get item data from local storage by given name
export const getItemFromLocalStorage = itemName => {
  if (localStorage.getItem(itemName) !== null) {
    var data = JSON.parse(localStorage.getItem(itemName));
    if (data.length > 0) return data;
  }
  return false;
};

//method to set given item data to local storage by given name
export const setItemToLocalStorage = (itemName, data) => {
  localStorage.setItem(itemName, JSON.stringify(data));
};

//get the selected language by user from local storage
export const getSelectedLanguage = () => {
  const storageLang = localStorage.getItem("language");
  if (storageLang) {
    let index = Langugaes.languages.findIndex(e => e.lang == storageLang);
    if (index >= 0) {
      return Langugaes.languages[index];
    }
  }
};

//translate strings
export const translate = key => {
  if (window.selectedLang) {
    if (window.selectedLang[key]) {
      return window.selectedLang[key];
    } else if (window.ukLang[key]) {
      return window.ukLang[key];
    } else {
      if (typeof key !== "undefined" && key.startsWith("lng_substate")) {
        // Due to a design flaw in the controller, we should filter out unused substates
        return "";
      } else {
        return key;
      }
    }
  }
};

// A timer function to start 15 sec timer to speedup update status
export const startStatusTimer = () => {
  window.localStorage.setItem("updateStatusTimer", 0);
  let status = 0;

  let updateInterval = setInterval(() => {
    status++;
    window.localStorage.setItem("updateStatusTimer", status);
  }, 1000);
  setTimeout(() => {
    clearInterval(updateInterval);
  }, 15000);
};
